export default {
  START_GET_HUB: 'START_GET_HUB',
  SUCCESS_GET_HUB: 'SUCCESS_GET_HUB',
  ERROR_GET_HUB: 'ERROR_GET_HUB',
  START_GET_SECTION: 'START_GET_SECTION',
  SUCCESS_GET_SECTION: 'SUCCESS_GET_SECTION',
  ERROR_GET_SECTION: 'ERROR_GET_SECTION',
  START_GET_SUBSECTION: 'START_GET_SUBSECTION',
  SUCCESS_GET_SUBSECTION: 'SUCCESS_GET_SUBSECTION',
  ERROR_GET_SUBSECTION: 'ERROR_GET_SUBSECTION',
};
